import { render } from "./langganan-kunci.vue?vue&type=template&id=a5e9ad9c&scoped=true"
import script from "./langganan-kunci.vue?vue&type=script&lang=js"
export * from "./langganan-kunci.vue?vue&type=script&lang=js"

import "./langganan-kunci.vue?vue&type=style&index=0&id=a5e9ad9c&scoped=true&lang=css"

import exportComponent from "../../../accutrax-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5e9ad9c"]])

export default __exports__